import {z as r} from 'zod';

export const sourceSettingsAccessSchema = r.object({
    hasAccess: r.boolean(),
});

export type SourceSettingsAccessType = r.infer<typeof sourceSettingsAccessSchema>;
